import { Box, Hidden } from "@mui/material";
import { ReactComponent as CloseIcon } from "../assets/images/close.svg";
import { ReactComponent as LogoIcon } from "../assets/images/logo.svg";
import {
  StepRoot,
  CloseRow,
  CloseButton,
  StepBody,
  StepTitle,
  StepSubtitle,
  FieldLabel,
  FieldGroup,
  DarkTextField,
  PrimaryButton,
} from "./ForgottenPasswordStyles";

const ForgottenPasswordEmailStep = ({ close, email, setEmail, handleSendToken }) => {
  return (
    <StepRoot>
      <CloseRow>
        <CloseButton onClick={close}>
          <CloseIcon />
        </CloseButton>
      </CloseRow>

      <StepBody>
        <StepTitle>שכחת סיסמה</StepTitle>
        <StepSubtitle>
          אופס, זה קורה לטובים שבינינו. תכניס את הכתובת מייל שלך בשביל לטפל בבעיה.
        </StepSubtitle>

        <FieldGroup>
          <FieldLabel>מייל</FieldLabel>
          <DarkTextField
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="example@gmail.com"
            id="email"
            variant="outlined"
          />
        </FieldGroup>

        <FieldGroup sx={{ marginBottom: 0 }}>
          <PrimaryButton
            onClick={handleSendToken}
            disabled={email.length < 1}
            variant="contained"
          >
            שלח
          </PrimaryButton>
        </FieldGroup>
      </StepBody>

      <Hidden mdUp>
        <Box sx={{ textAlign: "center", pb: "28px", "& svg": { height: "34px" } }}>
          <LogoIcon />
        </Box>
      </Hidden>
    </StepRoot>
  );
};

export default ForgottenPasswordEmailStep;
